import * as React from "react";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { PortfolioStatusPanel } from "../PortfolioStatusPanel";
import { useSyncStatus } from "@/hooks/queries/useSyncStatus";

interface SyncStatusPayload {
  has_run: boolean;
  summary: { results: Array<{ resource: string; is_success: boolean }> } | null;
}

/**
 * Reuses Sprint 3.2's `useSyncStatus` hook rather than duplicating it.
 * Reconciliation Status and a distinct "Portfolio Health" signal have no
 * backend read endpoint today - rendered honestly as unavailable.
 */
export function PortfolioHealthSection(): React.JSX.Element {
  const syncQuery = useSyncStatus();

  return (
    <QueryStateBoundary query={syncQuery}>
      {(payload) => {
        const sync = payload as unknown as SyncStatusPayload;
        const syncStatus = !sync.has_run
          ? "not_run"
          : sync.summary?.results.every((r) => r.is_success)
            ? "ok"
            : "degraded";
        return (
          <PortfolioStatusPanel
            data={{
              synchronizationStatus: syncStatus,
              reconciliationStatus: null,
              portfolioHealth: null,
            }}
          />
        );
      }}
    </QueryStateBoundary>
  );
}
